var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('core-layout-content',{attrs:{"medium":""}},[_c('core-layout-headline-and-actions',[_c('template',{slot:"headline"},[_vm._v("\n\t\t\t"+_vm._s(_vm.$t("my_account"))+"\n\t\t")])],2),_c('account-detail'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }